const axios = require('axios')
const instance = axios.create({
  baseURL: 'https://pure-dawn-82833.herokuapp.com'
})

instance.interceptors.response.use((response) => response, (error) => {
  console.log(`dari axios config`)
  Swal.fire({
    title: 'Error!',
    text: `${error.response.data.msg}`,
    icon: 'error'
  })
  // console.log(error.response.data.msg)
})

export default instance
